import "./App.css";
import { Link } from "react-router-dom";
import img1 from './imgs/greek salad.webp';
import img2 from './imgs/bruchetta.webp';
import img3 from './imgs/lemon dessert.webp';
import img from './imgs/motor-icon.webp'

function Specials() {
  const styles = {
    top: {
      display: 'flex',
      justifyContent: 'space-around',
      marginBottom: 20,
    },
    
    h2: {
      fontFamily: "Karla",
      fontKerning: 'auto',
    },
    
    button: {
      fontFamily: "Karla",
      padding: '10px 20px',
      borderRadius: 5,
      boxShadow: 'black',
    },
    belowCards: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    
    card: {
      display: 'flex',
      flexDirection: 'column',
      width: '30%',
    },
    
    foodDesc: {
      marginTop: -1,
      border: '1px solid black',
      borderTop: 'none',
      padding: '15px',
      boxShadow: '5px 10px #888888',
    },
    
    nameTagPrice: {
      display: 'flex',
      justifyContent: 'space-between',
      marginBottom: 10,
    },
    
    h5: {
      fontFamily: "Markazi Text",
    },
    
    h6: {
      fontFamily: "Karla",
      fontSize: 18,
      color: 'red',
    },
    
    foodDescP: {
      fontFamily: "Karla",
      fontSize: 15,
      marginBottom: 10,
    },
  };


 const menu = [{
  id: 0, // Used in JSX as a key
  name: 'Greek Salad',
  prices: '$12.99',
  description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia laboriosam odio debitis soluta, eligendi aliquam et dolore? Quibusdam cumque distinctio odit! Inventore veritatis consectetur fuga vel sequi ipsa id quisquam!',
  // img: {img1},
  img: img1,
}, {
 id: 1, 
 name: 'Berchecta',
 prices: '$5.99',
 description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia laboriosam odio debitis soluta, eligendi aliquam et dolore? Quibusdam cumque distinctio odit! Inventore veritatis consectetur fuga vel sequi ipsa id quisquam!',
 img: img2,
},{
 id: 2, 
 name: 'Lemon Dessert',
 prices: '$5.00',
 description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quia laboriosam odio debitis soluta, eligendi aliquam et dolore? Quibusdam cumque distinctio odit! Inventore veritatis consectetur fuga vel sequi ipsa id quisquam!',
 img: img3,
}];


const menus = menu.map(menu =>

 <article style={styles.card}>
  <img src={menu.img} alt="food__tease" />
  <div style={styles.foodDesc}>
   <div style={styles.nameTagPrice}>
    <h5 style={styles.h5}>{menu.name}</h5>
    <h6 style={styles.h6}>{menu.prices}</h6>
   </div>
   <p style={styles.foodDescP}>
   {menu.description}
   </p>
   <Link to="/">Order a delivery</Link>
   <img src={img} style={{width: '32px', height: '20px', display: 'inline-block'}} alt="motor-icon" />
  </div>
 </article>,

{/*
    
              <Link to="/">
              Order a delivery <span style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/motor-icon.ico)`, width: '32px', height: '20px', display: 'inline-block' }}></span>
        </Link>     
    </div> */}
           
         


);
return   <div><div style={styles.top}>
<h2 style={styles.h2}>Specials</h2>
<button style={styles.button}>Online Menu</button>
</div><div style={styles.belowCards}>{menus}</div></div>;
}

export default Specials;
